import React from 'react';
import { OnboardingSetupPage } from 'src/components/Onboarding/OnboardingSetupPage';

function action(context) {
  const isInternalUser = context.portalConfig.viewMode === 'internal';
  return {
    chunks: ['onboarding-setup'],
    ...(isInternalUser
      ? {
          description: 'Sign up for a Copilot account.',
          title: 'Copilot • Sign up',
        }
      : {}),
    component: <OnboardingSetupPage />,
  };
}

export default action;
